function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cn from 'classnames';
import get from 'lodash/get';
import FormContainerAbstract from 'components/FormContainerAbstract';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import App from 'modules/App';
import accessTokenShape from 'shapes/accessTokenShape';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import CloudDrive from 'modules/CloudDrive';
import Visit from 'modules/Visit';
import * as constants from '../../../../constants';
import messages from '../../../../messages';
import * as styles from '../Forms.pcss';
import DateTimePicker from '../../../../partials/DateTimePicker';
import { getTimestamp } from '../../../../helpers';
import validatorRules from './validatorRules.json';
const ID = constants.RESULT_TYPE.TRIGLYCERIDES[0].toLowerCase() + constants.RESULT_TYPE.TRIGLYCERIDES.slice(1);
class TriglyceridesForm extends FormContainerAbstract {
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (errors) {
            return;
        }
        const { patient, phiSet, phiSetDocumentId, activeVisit, onSuccess, metricsConversions } = this.props;
        const { [`${ID}DateTimestamp`]: dateTimestamp, time } = validatedValues;
        const visitData = {
            phisetVisitId: get(activeVisit, 'phisetVisitId'),
            timestamp: getTimestamp(dateTimestamp, time)
        };
        let { triglycerides } = validatedValues;
        const { triglycerides: triglyceridesConversion } = metricsConversions;
        if (triglyceridesConversion.unit === 'MMOL_L') {
            triglycerides = triglyceridesConversion.toStorage(triglycerides);
        }
        this.props.onSubmit({
            triglycerides
        }, phiSet, phiSetDocumentId, patient, visitData, onSuccess);
    }
    renderTriglyceridesRow() {
        const { isInProgress, metricsConversions } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.root__row,
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.root__cell, styles['root__cell--singleCell']),
                children: [
                    /*#__PURE__*/ _jsx(FormGroup, {
                        id: "triglycerides",
                        labelMessage: messages.labels.triglycerides,
                        formValues: this.props.formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            inputValue: "true",
                            type: "number",
                            attributes: {
                                maxLength: 6
                            },
                            labelMessage: messages.labels.triglycerides,
                            isDisabled: this.props.isInProgress,
                            onChange: this.props.onSetFormValue
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.root__unit, {
                            [styles['root__unit--disabled']]: isInProgress
                        }),
                        children: metricsConversions.triglycerides.unitSymbol
                    })
                ]
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            className: styles.root,
            onSubmit: ()=>this.onSubmit(),
            children: [
                this.renderTriglyceridesRow(),
                /*#__PURE__*/ _jsx(DateTimePicker, {
                    id: ID,
                    formName: constants.TRIGLYCERIDES_FORM,
                    isDisabled: this.props.isInProgress
                }),
                /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    type: "submit",
                    labelMessage: messages.buttons.saveResult,
                    className: "btn--filled",
                    isInProgress: this.props.isInProgress
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
    }
}
_define_property(TriglyceridesForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    locale: PropTypes.string,
    formValues: PropTypes.object,
    phiSet: PropTypes.object,
    phiSetDocumentId: PropTypes.string,
    patient: PropTypes.shape({
        id: PropTypes.string.isRequired,
        countryId: PropTypes.number.isRequired,
        phiSetReferenceKey: PropTypes.string,
        storageProvider: PropTypes.string,
        accessToken: accessTokenShape,
        firstName: PropTypes.string,
        lastName: PropTypes.string
    }),
    metricsConversions: PropTypes.object,
    // Implicit props
    isInProgress: PropTypes.bool,
    // Explicit actions
    onSubmit: PropTypes.func,
    onSuccess: PropTypes.func,
    // Implicit actions
    onSetFormValue: PropTypes.func,
    onSetFormProcessing: PropTypes.func,
    onSetFormValues: PropTypes.func,
    onFormErrors: PropTypes.func
}));
const mapStateToProps = ()=>(state)=>({
            locale: App.selectors.locale(state),
            formValues: App.selectors.formSelector(constants.TRIGLYCERIDES_FORM)(state),
            isInProgress: CloudDrive.selectors.isStoreMeasurementsInProgress(state),
            activeVisit: Visit.selectors.activeVisit(state)
        });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.TRIGLYCERIDES_FORM;
    return {
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedTriglyceridesForm = connect(mapStateToProps, mapDispatchToProps)(injectIntl(TriglyceridesForm));
export default withStyles(styles)(ConnectedTriglyceridesForm);
